import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import R from 'ramda';
import ShowHide from '@cotyorg/ccx-utils/js/components/ShowHide';
import SubcategoryNavigationList from '../SubcategoryNavigationList';

const getChevronSrc = (isOpen) =>
  isOpen
    ? '/ccx-files/assets/chevron-up.svg'
    : '/ccx-files/assets/chevron-down.svg';

const getSelectedText = R.compose(
  (item) =>
    `${R.propOr('', 'name')(item)} (${R.propOr('', 'productCount')(item)})`,
  R.find(({ isSelected }) => isSelected)
);

const getNotSelectedItems = R.filter(({ isSelected }) => !isSelected);

const SubcategoryNavigation = ({
  items = [],
  currentBreakpoint = '',
  isOpen,
  toggle,
  dropdownIconWidth,
  dropdownIconHeight,
}) => (
  <div className="subcategory-navigation">
    {currentBreakpoint.includes('large') ? (
      <SubcategoryNavigationList items={items} />
    ) : (
      <>
        <div className="flex-container align-center">
          <button
            className="link icon-link subcategory-navigation__link subcategory-navigation__icon-link"
            onClick={toggle}
            type="button"
          >
            <span className="icon-link__text subcategory-navigation__link-text">
              {getSelectedText(items)}
            </span>
            <img
              className="icon"
              alt=""
              src={getChevronSrc(isOpen)}
              width={dropdownIconWidth}
              height={dropdownIconHeight}
            />
          </button>
        </div>
        <ShowHide
          isOpen={isOpen}
          extraClass="subcategory-navigation__show-hide"
          noTransitionClass="subcategory-navigation__show-hide--no-transition"
        >
          <SubcategoryNavigationList
            items={getNotSelectedItems(items)}
            isHiddenList
          />
        </ShowHide>
      </>
    )}
  </div>
);

SubcategoryNavigation.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object),
  currentBreakpoint: PropTypes.string,
  isOpen: PropTypes.bool,
  toggle: PropTypes.func,
  dropdownIconWidth: PropTypes.number,
  dropdownIconHeight: PropTypes.number,
};

export default SubcategoryNavigation;
